<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>操作日志</span>
      <el-button size="mini" @click="load">刷新</el-button>
    </div>

    <div class="search-bar">
      <el-input
        v-model.trim="query.operatorName"
        placeholder="请输入操作人"
        clearable
        style="width: 220px"
        @keyup.enter.native="handleSearch"
      />
      <el-input
        v-model.trim="query.menuName"
        placeholder="请输入操作菜单"
        clearable
        style="width: 220px"
        @keyup.enter.native="handleSearch"
      />
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="id" label="编号" width="80" />
      <el-table-column prop="operatorName" label="操作人" min-width="110" />
      <el-table-column prop="menuName" label="操作菜单" min-width="120" />
      <el-table-column prop="ipAddress" label="IP地址" min-width="120" />
      <el-table-column label="请求参数" min-width="180">
        <template slot-scope="{ row }">
          <span class="ellipsis-text" :title="row.requestParams || ''">{{ row.requestParams || '-' }}</span>
          <el-button v-if="row.requestParams" type="text" size="mini" @click="showDetail('请求参数', row.requestParams)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="SQL信息" min-width="180">
        <template slot-scope="{ row }">
          <span class="ellipsis-text" :title="row.sqlText || ''">{{ row.sqlText || '-' }}</span>
          <el-button v-if="row.sqlText" type="text" size="mini" @click="showDetail('SQL信息', row.sqlText)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="返回结果" width="100">
        <template slot-scope="{ row }">
          <el-tag :type="Number(row.resultCode) === 0 ? 'success' : 'danger'" size="mini">
            {{ Number(row.resultCode) === 0 ? '成功' : '失败' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="返回信息" min-width="180">
        <template slot-scope="{ row }">
          <span class="ellipsis-text" :title="row.resultMsg || ''">{{ row.resultMsg || '-' }}</span>
          <el-button v-if="row.resultMsg" type="text" size="mini" @click="showDetail('返回信息', row.resultMsg)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="operationTime" label="操作时间" min-width="170" />
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog :title="detailTitle" :visible.sync="detailVisible" width="720px">
      <pre class="detail-content">{{ detailContent }}</pre>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'

export default {
  data () {
    return {
      list: [],
      total: 0,
      detailVisible: false,
      detailTitle: '',
      detailContent: '',
      query: {
        page: 1,
        limit: 10,
        operatorName: '',
        menuName: ''
      }
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      const { data } = await http.get('/sys/operation-log/page', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = {
        page: 1,
        limit: 10,
        operatorName: '',
        menuName: ''
      }
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    showDetail (title, content) {
      this.detailTitle = title
      this.detailContent = content || ''
      this.detailVisible = true
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.ellipsis-text {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.detail-content {
  max-height: 420px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 12px;
  margin: 0;
}
</style>
